"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowElement = exports.ElementTypes = void 0;
var React = require("react");
var editableCell_1 = require("../editableList/editableCell");
var deadline_1 = require("../editableList/deadline");
var ElementTypes = (function () {
    function ElementTypes() {
    }
    ElementTypes.risk = 'risk';
    ElementTypes.control = 'control';
    ElementTypes.action = 'action';
    return ElementTypes;
}());
exports.ElementTypes = ElementTypes;
var TableRowElement = function (props) {
    var extraTableData;
    var colspan = 0;
    switch (props.elementType) {
        case ElementTypes.risk:
            colspan = 3;
            break;
        case ElementTypes.control:
            extraTableData = (React.createElement("td", { className: "space" }, "\u00A0"));
            colspan = 2;
            break;
        case ElementTypes.action:
            extraTableData = (React.createElement(React.Fragment, null,
                React.createElement("td", { className: "space" }, "\u00A0"),
                React.createElement("td", { className: "space" }, "\u00A0")));
            colspan = 1;
            break;
        default:
            throw new Error("Invalid elementType");
    }
    return (React.createElement(React.Fragment, null,
        extraTableData,
        React.createElement("th", { colSpan: colspan, scope: "row" }, props.number),
        React.createElement("td", null, props.title),
        props.deadline ?
            React.createElement("td", null,
                React.createElement(deadline_1.default, { date: props.deadline, urgency: editableCell_1.EditableDate.computeUrgency(props.deadline) }))
            :
                React.createElement("td", null, "\u00A0"),
        React.createElement("td", null, props.status_display),
        React.createElement("td", null, props.owner)));
};
exports.TableRowElement = TableRowElement;
